import { render, staticRenderFns } from "./AddTicket.vue?vue&type=template&id=eddf2afa&scoped=true"
import script from "./AddTicket.vue?vue&type=script&lang=js"
export * from "./AddTicket.vue?vue&type=script&lang=js"
import style0 from "./AddTicket.vue?vue&type=style&index=0&id=eddf2afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddf2afa",
  null
  
)

export default component.exports